<template>
  <div>
    <router-view v-if="isSignedIn || tokenIsValid || isOpenAccess" />
  </div>
</template>
<script>
import nbIotAuth from '../../mixins/auth/nb-iot-auth';

export default {
  mixins: [nbIotAuth],
};
</script>
